import './currency';
import './date';
import './float';
import './integer';
import './numeric';
import './person-id';
import './postal-code';
